import { useQuery } from "react-query"
import { AxiosResponse } from "axios"

import { IGetLaundryCancelCommissionsRes } from "types/laundry"

import laundriesService from "api/laundriesService"

const useGetLaundryCancelCommissions = (laundryIds: number[], enabled: boolean) => {
  return useQuery(["laundry_cancel_commissions", { laundryIds }], async () => {
    try {
      const res: AxiosResponse<IGetLaundryCancelCommissionsRes> = await laundriesService.getLaundryCancelCommissions(laundryIds)

      return res.data
    } catch(err: any) {
      return err.response
    }
  }, { enabled, refetchOnWindowFocus: false })
}

export default useGetLaundryCancelCommissions